
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{staticClass:"icon-stroke",attrs:{"stroke":"#fff","stroke-width":"5.875","d":"M19.5 3.25L32.25 16 19.5 28.75M32.25 16H3.75"}}),_c('path',{staticClass:"icon-stroke-outline",attrs:{"stroke":"#E60000","stroke-width":"1.875","d":"M19.5 3.25L32.25 16 19.5 28.75M32.25 16H3.75"}})])])
          )
        }
      }
    